import {Component, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {Subject} from 'rxjs/internal/Subject';
import {DtoProductGroupVM} from '../../../Model/price-list/DtoProductGroupVM';
import {AuthService} from '../../../Shared/Services/auth.service';
import {PriceListService} from '../../../Services/price-list.service';
import {environment} from '../../../../environments/environment'
import {NgxSpinnerService} from 'ngx-spinner';
import {SharedService} from '../../../Shared/Services/shared.service';
import {Router} from '@angular/router';
import {UserType} from '../../../Shared/Enums/UserType';
import {DtoProductsVM} from '../../../Model/price-list/DtoProductsVM';
import {DtoBuySellOrderVm} from "../../../Model/items/DtoBuySellOrderVm";
import {BuySellOrderService} from "../../../Services/buy-sell-order.service";
import {LoginVm} from "../../../Model/LoginVM";

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrl: './order-list.component.scss'
})
export class BuySellOrderListComponent implements OnInit {
  imgPath: string = environment.ImgUrl;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  selectedOrder: DtoBuySellOrderVm | null = null;
  orders: DtoBuySellOrderVm[] = [];
  allOrders: DtoBuySellOrderVm[] = [];
  selectedOrderData: DtoBuySellOrderVm | null = null;
  currentUser: LoginVm = {};
  isExpanded: boolean = false;
  addNew: boolean = false;
  showAdd: boolean = false;

  constructor(private api: BuySellOrderService, private auth: AuthService, private spinner: NgxSpinnerService,
              private shared: SharedService, private router: Router) {
  }

  ngOnInit() {
    this.currentUser = this.auth.getCurrentUser();
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      if(this.currentUser.userType == UserType.Agent){
        this.showAdd = true;
      }
      this.spinner.show();
      this.GetOrders();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetOrders() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      this.api.GetAll()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
          res.payload.forEach((o: DtoBuySellOrderVm) => o.date = new Date(o.date));
          this.orders = res.payload;
          this.allOrders = res.payload;
          this.spinner.hide();
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  checkSearchVal(searchVal?: any) {
    let orders = this.shared.checkSearchVal(this.orders, this.allOrders, searchVal, 'supplierName');
    orders = orders.concat(this.allOrders.filter(x => x.date.toString().indexOf(searchVal) === -1));
    this.orders = orders;
  }

  ShowOrder(order: DtoBuySellOrderVm | null) {
    this.selectedOrderData = null;
    if (!order) {
      this.addNew = true;
    } else {
      this.api.Get(order.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
          this.selectedOrderData = res.payload;
          this.spinner.hide();
        });
    }
  }

  Back(){
    this.addNew = false;
    this.selectedOrderData = null;
  }

  expandItems() {
    this.isExpanded = !this.isExpanded;
  }
}
